<script setup lang="ts">
    import { marked } from 'marked';
    import { computed } from 'vue';
    import DOMPurify from 'dompurify';

    const props = defineProps<{
        markdown: string;
        breaks?: boolean;
    }>();

    const renderedAndSanitizedMarkdown = computed<string>(() => {
        let parsedMarkdown = marked.parse(props.markdown, {
            breaks: props.breaks ?? false,
        }) as string;
        if (parsedMarkdown.includes('<table')) {
            parsedMarkdown = parsedMarkdown
                .replace(/<table/g, '<div class="table-wrapper"><table')
                .replace(/<\/table>/g, '</table></div>');
        }

        return DOMPurify.sanitize(parsedMarkdown);
    });
</script>

<template>
    <!-- eslint-disable-next-line vue/no-v-html -- sanitized with DOMPurify -->
    <div class="From-markdown" v-html="renderedAndSanitizedMarkdown" />
</template>
